(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["safe-space-testimonials"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialise = (section) => {
      if (!section || section.dataset.initialised === 'true') return;
      section.dataset.initialised = 'true';

      const slides = Array.from(section.querySelectorAll('[data-slide]'));
      const dots = Array.from(section.querySelectorAll('[data-target]'));
      if (slides.length < 2) return;

      let current = 0;
      let timer;

      const show = (index) => {
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, slideIndex) => {
          const active = slideIndex === current;
          slide.hidden = !active;
          slide.classList.toggle('is-active', active);
        });
        dots.forEach((dot, dotIndex) => {
          const active = dotIndex === current;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      };

      const stop = () => {
        if (timer) window.clearInterval(timer);
      };

      const start = () => {
        stop();
        if (section.dataset.autoplay === 'true') {
          const speed = Number(section.dataset.speed) || 5000;
          timer = window.setInterval(() => show(current + 1), speed);
        }
      };

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          show(Number(dot.dataset.target));
          start();
        });
      });

      section.addEventListener('mouseenter', stop);
      section.addEventListener('mouseleave', start);
      section.addEventListener('focusin', stop);
      section.addEventListener('focusout', start);
      section.addEventListener('touchstart', stop, { passive: true });
      section.addEventListener('touchend', start, { passive: true });
      start();
    };

    document.querySelectorAll('.safe-space-testimonials').forEach(initialise);
    document.addEventListener('shopify:section:load', (event) => {
      initialise(event.target.querySelector('.safe-space-testimonials'));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
